import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=0e440a88&scoped=true&"
import script from "./inventoryDetails.vue?vue&type=script&lang=js&"
export * from "./inventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./inventoryDetails.vue?vue&type=style&index=0&id=0e440a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e440a88",
  null
  
)

export default component.exports